<span *ngIf="hasCount" class="rail-badge" [class.rail-badge--dot]="dot" role="status" aria-live="polite" [attr.aria-label]="ariaLabel">
  <span *ngIf="!dot" class="rail-badge__count" aria-hidden="true">{{ displayCount }}</span>
</span>
